module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel.43295687.png";